export const arraysIntersection = <T extends number | string>(arrayA: T[], arrayB: T[]) => {
    return arrayA.filter(x => arrayB.includes(x));
};
